import { AircraftLogSelectorState } from './reducers';

export const getAircraftLogSelector = ({ aircraftLogSelector }) =>
  aircraftLogSelector as AircraftLogSelectorState;
